import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { stringify } from 'query-string';

import { Button } from '@components';
import { reqSaveMyDealerAction } from '@stores/locations/actions';
import { useSelectedRetailerSelector } from '@stores/locations/selectors';
import DealerService from '@services/dealerService';
import styles from './LocationRail.module.scss';
import SelectedArrow from '../../public/selected-arrow.svg';
import Star from '../../public/Star.svg';
import StarSelected from '../../public/Star-selected.svg';

const alphanumericRegex = /[^A-Za-z0-9]/g;
const dealerService = DealerService();

const Location = ({
  location,
  index,
  callback,
  selected,
  flow,
  productId: product,
  isUsed,
  showSaveLinkText,
  saveLinkText,
  showDetailsLinkText,
  detailsLinkText,
}) => {
  const [active, setActive] = useState(styles.notActive);
  const myDealer = useSelector(useSelectedRetailerSelector);
  const [dealer, setDealer] = useState(null);
  const dispatch = useDispatch();

  const saveMyDealer = () => {
    dispatch(reqSaveMyDealerAction({ location }));
  };

  useEffect(async () => {
    if (location?.code) {
      try {
        const dealerInfo = await dealerService.getDealerInfo({ dealerCode: location?.code });
        setDealer(dealerInfo[0]);
      } catch (error) {
        console.error(error);
      }
    }
  }, [location?.code]);

  useEffect(() => {
    if (index === selected) {
      setActive(styles.active);
    } else {
      setActive(styles.notActive);
    }
  }, [selected]);

  // Format distance display object
  const km = parseInt(location.distance) / 1000;
  let converted = km.toFixed(2) + ' KM';
  if (km === 0) {
    converted = parseFloat(location.distance).toFixed(2) + ' M';
  }

  const starClass = myDealer?.name === location.name ? <StarSelected /> : <Star />;

  // Return formatted Phone Number
  const normalizePhoneNumber = (phone) => {
    phone = phone?.replace(/[^\d]/g, '');
    if (phone?.length == 10) {
      return phone?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    return null;
  };

  const markerPinDefault = index === selected ? <img src="../Orange_Pin.svg" /> : <img src="../Black_Pin.svg" />;

  const selectedLocation = (clicked) => {
    callback(parseInt(clicked));
  };

  return (
    <div className={classNames(styles.LocationBlock, active)} onClick={() => selectedLocation(index)}>
      <div className={styles.innerWrapper}>
        <div className={styles.FlexBox}>
          <div className={styles.Marker}>
            <div>{index + 1}</div>
            <div className={styles.mapIcon}>{markerPinDefault}</div>
          </div>
          <div className={styles.DealerContentWrapper}>
            <div>
              <p className={styles.dest}>{converted}</p>
            </div>
            <div>
              <h3>{location.name}</h3>
            </div>
            <div>
              <p className={styles.Address}>
                {location.address1} {location.address2} <br />
                {location.city}, {location.province}, {location.postal}
                <br />
                {normalizePhoneNumber(location.phone)}
              </p>
            </div>
            {index === 0 && location?.code && (
              <div>
                <img src={`/api/static/resource/dealerlogo/${location?.code.replace(alphanumericRegex, '')}.png`} className={styles.Logo} />
              </div>
            )}
            <div className={styles.FlexGroup}>
              {flow === 'contact' ? (
                <div>
                  {dealer?.dealerURLName && (
                    <Link
                      href={`/dealer/contact-a-dealer?dealer=${dealer.dealerURLName}&${stringify({ product, isUsed })}`}
                      className={styles.contact__dealer__button}
                      prefetch={false}
                    >
                      <Button animated className={styles.locationButton}>
                        Select Dealer
                      </Button>
                    </Link>
                  )}
                </div>
              ) : (
                <>
                  <div>
                    {dealer?.dealerURLName && (
                      <p>
                        <Link
                          href={`/find-a-dealer/${dealer.dealerURLName}?${stringify({ product, isUsed })}`}
                          prefetch={false}
                        >
                          <a className={styles.locationLink}>{showDetailsLinkText ? detailsLinkText : null}</a>
                        </Link>
                      </p>
                    )}
                  </div>
                  <div className={styles.SaveDealerBtn} onClick={() => saveMyDealer()}>
                    <span className={styles.Star}>{starClass}</span>
                    <span className={styles.locationLink}>{showSaveLinkText ? saveLinkText : null}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Location;
